// Route /admin/kontakte/:quelle/:id – leitet alte Kontakt-Links auf die heutigen Detailseiten um (lib/kontakte/umleitung.ts).
import { Navigate, useParams } from 'react-router-dom';
import { alterKontaktPfadZiel } from '../../../lib/kontakte/umleitung';

export default function KontaktUmleitung() {
  const { quelle, id } = useParams<{ quelle: string; id: string }>();
  return <Navigate to={alterKontaktPfadZiel(quelle, id)} replace />;
}
